import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRouter } from "next/router";
import Image from "next/image";
import { Pagination } from "swiper";
import { useTranslations } from "next-intl";
import "swiper/css";
import "swiper/css/pagination";
const WMAD_slider = () => {
  const array = [1, 2, 3];
  const t = useTranslations("aboutUs.WMAD.slider");
  const router = useRouter();
  const result = array?.map((element, index) => {
    return (
      <SwiperSlide virtualIndex={element.title}>
        <div
          className="flex md:ml-[10px] items-center justify-center "
          key={element.title}
        >
          <div className="WMAD w-[80%] xlg:w-[378px]  mds:h-[403px] h-[413px] rounded-[10px] flex flex-col pt-[25px]  items-center  border-2 border-[#626289]  ">
            <div className="rounded-[10px] w-[90%] xlg:w-[327px] h-[140px] mb-[15px] relative">
              <Image
                src={t(`${index}.image`)}
                layout="fill"
                alt="ascot testamonials"
                className="object-cover"
              />
            </div>
            <p className="text-[#F6F6F6] text-[24px]  w-[90%] font-[590] leading-[24px] mb-[15px]">
              {t(`${index}.title`)}
            </p>
            <p className="text-[#F6F6F6] mb-[25px] w-[90%] xlg:w-[327px] ">
              {t(`${index}.descrption`)}
            </p>
          </div>
        </div>
      </SwiperSlide>
    );
  });
  return (
    <>
      <div className=" flex  items-center w-[100%] justify-center  mt-[51px] ">
        <Swiper
          className="h-[515px]"
          key={router.locale}
          modules={[Pagination]}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2, spaceBetween: 0 },
            1025: { slidesPerView: 3, spaceBetween: 0 },
          }}
          pagination={{ clickable: true }}
          style={{
            "--swiper-pagination-color": "#0AF0DD",
            "--swiper-pagination-bullet-inactive-color": "#ffffff4d",
            "--swiper-pagination-bullet-inactive-opacity": "1",
          }}
          id="WMAD_slider"
        >
          {result}
        </Swiper>
      </div>
    </>
  );
};

export default WMAD_slider;
